import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth, ProtectedRoute } from './src/contexts/IframeAuthProvider';
import LoginPage from './src/pages/LoginPage';
import { CasesHomePage } from './src/pages/CasesHomePage';
import { CaseEditorPage } from './src/pages/CaseEditorPage';
import { LoadingPage } from './src/pages/LoadingPage';

function App() {
  const { isLoading, isAuthenticated } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      {/* Public routes */}
      <Route
        path="/login"
        element={
          isAuthenticated ? (
            <Navigate to="/" replace />
          ) : (
            <LoginPage />
          )
        }
      />

      {/* Protected routes */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <CasesHomePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/cases/:caseId"
        element={
          <ProtectedRoute>
            <CaseEditorPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/loading"
        element={
          <ProtectedRoute>
            <LoadingPage />
          </ProtectedRoute>
        }
      />

      {/* Catch-all redirect */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;